import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { CurrentUserService } from '../auth/current-user.service';

@Directive({ selector: '[appHasPrivilege]' })
export class HasPrivilegeDirective implements OnInit {
  @Input() appHasPrivilege: string | string[] = [];

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private currentUserService: CurrentUserService
  ) {}

  ngOnInit(): void {
    this.currentUserService.ensureLoaded().subscribe(() => {
      const codes = Array.isArray(this.appHasPrivilege) ? this.appHasPrivilege : [this.appHasPrivilege];
      this.viewContainer.clear();
      if (this.currentUserService.hasAnyPrivilege(codes)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }
}
